<template>
  <div>
    <div> <!-- :pagination.sync="pagination" :total-items="totalItems" -->
      <v-data-table :headers="headers" :items="people" hide-actions class="elevation-1"
            :loading="loading" noDataText="Searching...">
        <template slot="items" slot-scope="props">
          <td class="text-xs-left pa-1">
              <router-link :to="{path: '/person/' + props.item.id}">
              {{ $prettyName(props.item.surname) }}, {{ $prettyName(props.item.firstNames) }}
              </router-link>
          <td class="text-xs-left pa-2">{{ $renderSingleValues(props.item.service) }}</td>                   
          <td class="text-xs-left pa-2">{{ $renderStandardListNoLink(props.item.serviceNum) }}</td>                 

          <td class="text-xs-left pa-2" nowrap='nowrap'>{{ props.item.birthDate }}</td>
          <td class="text-xs-left pa-2" nowrap='nowrap'>{{ getEnlistDate(props.item.bio) }}</td>
          <td class="text-xs-left pa-2"> <!-- v-html="$placeSummary(props.item.addressAtEnlistment)"/ -->
            <place-summary v-bind:place="props.item.addressAtEnlistment"></place-summary>
          </td>

          <td class="text-xs-left pa-2">
              <list-with-links v-bind:field="props.item.rank" fieldName="rank"></list-with-links>
              <!-- span v-html="$renderStandardListWithLink(props.item.rank, 'rank')"></span -->
          </td>
          <td class="text-xs-left pa-2" v-if="showUnitCol">
            <list-with-links v-bind:field="props.item.unit" fieldName="unit"></list-with-links>
            <!--<span v-html="$renderStandardListWithLink(props.item.unit, 'unit')"></span -->
          </td>
          <td class="text-xs-left pa-2" nowrap='nowrap'>{{ props.item.pow }}</td> <!-- 30jan25 -->
        </template>
        <template slot="footer">
          <!-- td :colspan="headers.length" style="margin:0;padding:0" -->
          <td :colspan="1" style="margin:0;padding:0">
            <v-layout row wrap pa-0 ma-0>

              <v-flex xs6 sm6 md6 >
                <v-text-field box
                  v-model="queryParam.surname" v-on:keyup.enter="reloadSearch" label="Surname"></v-text-field>
              </v-flex>
              <v-flex xs6 sm6 md6 >
                <v-text-field box
                  v-model="queryParam.firstNames" v-on:keyup.enter="reloadSearch" label="First names"></v-text-field>
              </v-flex>
            </v-layout>
          </td>
          <td :colspan="1" style="margin:0;padding:0">
            <v-layout row wrap pa-0 ma-0>
              <v-flex >
                <v-select box label="Service" v-model="queryParam.service" v-on:change="reloadSearch"
                  :items=$serviceValues></v-select>
                <!--
                  v-on:change="reloadSearch"
                <v-text-field box
                  v-model="service" v-on:keyup.enter="reloadSearch" label="Search Service"></v-text-field>
                -->
              </v-flex>
            </v-layout>
          </td>                
          <td :colspan="1" style="margin:0;padding:0">
            <v-layout row wrap pa-0 ma-0>
              <v-flex >              
                <v-text-field box
                  v-model="queryParam.serviceNum" v-on:keyup.enter="reloadSearch" label="Number"></v-text-field>
              </v-flex>
            </v-layout>
          </td>

          <td :colspan="3">
          </td>
          <td :colspan="1" style="margin:0;padding:0">
            <v-layout row wrap pa-0 ma-0>                    
              <v-flex>
                <v-text-field box
                  v-model="queryParam.rankName" v-on:keyup.enter="reloadSearch" label="Rank"></v-text-field>
              </v-flex>
              </v-layout>
          </td>
          <td :colspan="1" style="margin:0;padding:0"  v-if="showUnitCol">
            <v-layout row wrap pa-0 ma-0>
              <v-flex >
                <v-text-field box
                  v-model="queryParam.unitName" v-on:keyup.enter="reloadSearch" label="Unit"></v-text-field>
              </v-flex>
            </v-layout>
          </td>
          <td :colspan="1" style="margin:0;padding:0"  nowrap="nowrap">
            <v-layout row wrap pa-0 ma-0>
              <v-flex >
                <v-text-field box
                  v-model="queryParam.pow" v-on:keyup.enter="reloadSearch" label="POW"></v-text-field>
              </v-flex>
            </v-layout>
          </td>          
        </template>
        <template slot="no-data">
          <div v-if="(finalCount === 0)">
          <v-alert
            :value="true"
            color="error"
            icon="warning"
          >Nothing found :(</v-alert></div>
        </template>
      </v-data-table>
    </div>

    <div style='margin-top:10px;margin-bottom:10px'>           
      <v-btn  class="blue-grey lighten-3" @click='goto(0)' :disabled=isAtStart>Start</v-btn>  
      <v-btn  class="blue-grey lighten-3" @click='goto(-1)' :disabled=isAtStart>Prev</v-btn>  
      <v-btn  class="blue-grey lighten-3" @click='goto(1)' :disabled=isAtEnd>Next</v-btn>
      <v-btn  class="blue-grey lighten-3" @click='goto(2)' :disabled=endIsUnknownOrNotThere>End</v-btn>
    </div>

  </div>

</template>

<script>
import PeopleService from "@/services/PeopleService" ;
import RankService from "@/services/RankService";
// import Panel from "@/components/Panel" ;
export default {
  components: {
    // Panel
  },
  props: {
    showUnitCol: { type: Boolean, default: true },
    forceUnitId: { type: Number, default: -1 },
    forceRankId: { type: Number, default: -1 },
    forceRankType: { type: String, default: '' },
    forceBirthPlaceId: { type: Number, default: -1 },
    forceHonourRollPlaceId: { type: Number, default: -1 },
    forceEnlistPlaceId: { type: Number, default: -1 },
    forceEnlistAddressPlaceId: { type: Number, default: -1 },
    forceHomePortPlaceId: { type: Number, default: -1 },
    forceCemeteryId: { type: Number, default: -1 }
    // forcePow: { type: String, default: '' } // 30jan25

  },
  data () {
    return {
      queryParam: {
        surname: '',
        firstNames: '',
        serviceNum: '',
        service: '',
        rankName: '',
        unitName: '',
        relType: '',
        relValue: '',
        description: '',
        unitId: 0,
        rankId: 0,
        rankType: '',        
        birthPlaceId: 0,
        honourRollPlaceId: 0,
        enlistPlaceId: 0,
        enlistAddressPlaceId: 0,
        cemeteryId: 0,
        homePortPlaceId: 0,
        naaDigitype: null,
        pow: '', // 30jan25

        start: 0,
        limit: 15
      },

      /*
      rankItems: [],
      rankLoading: false,
      rankSearch: null,
      */
      people: [ ],

      totalItems: 0,
      finalCount: -1,
      loading: true,
      pagination: {},
      // serviceValues: ['All', 'Army', 'Merchant Navy', 'RAAF', 'RAN'],
      headers: [
        { 
          text: "Name",
          align: "left",
          sortable: false,
          width: "30%",
          class: "pa-1"
        },
        { text: "Service", sortable: false, width: "8%", class: "pa-2" },
        { text: "Number", sortable: false, width: "8%", class: "pa-2" },
        { text: "Born", sortable: false, width: "1%", class: "pa-2" },
        { text: "Enlisted", sortable: false, width: "1%", class: "pa-12" },
        {
          text: "Address at enlist",
          sortable: false,
          width: "10%",
          class: "pa-2"
        },
        { text: "Final Rank", sortable: false, width: "10%", class: "pa-2" },
        { text: "Final Unit", sortable: false, width: "25%", class: "pa-2" },
        { text: "POW", sortable: false, width: "5%", class: "pa-2" }], 
      queryFields: ['surname', 'firstNames', 'serviceNum', 'service', 'rankName', 
        'unitName', 'relType', 'relValue', 'description', 'showUnique', 'naaDigitype', 'pow']         
     
    };
  },
  async created () {
    // await this.$getCodes() ;  // needed for everything - make sure we have them and they are up to date
  },  
  methods: {
    
    async goto (inc) {
      if (inc === 1) {
        if (this.finalCount < 0) this.queryParam.start += this.queryParam.limit ;
        else if ((this.queryParam.start + this.queryParam.limit) < this.finalCount) this.queryParam.start += this.queryParam.limit ;
      }
      else if (inc === -1) {
        this.queryParam.start -= this.queryParam.limit ;
        if (this.queryParam.start < 0) this.queryParam.start = 0 ;
      }
      else if (inc === 2) { // goto the end
        this.queryParam.start = this.finalCount - this.queryParam.limit ;
        if (this.queryParam.start < 0) this.queryParam.start = 0 ;
      }
      else this.queryParam.start = 0 ;
      await this.readData() ;
    },

    reloadSearch () {   

      const route = {
        name: this.$route.name,
        query: { }
      }
      var description = "" ;
      for (var i = 0 ; i < this.queryFields.length ; i++) {
        const qf = this.queryFields[i] ;
        if (this.queryParam[qf].length > 0) {
          route.query[qf] = this.queryParam[qf] ;
          if (qf !== "description") description += " " + qf + ":" + this.queryParam[qf] ;
        }
        else route.query[qf] = null ;
      }
      route.query.description = description ;
      console.log("RELOAD SEARCH-------------------" + JSON.stringify(route)) ;
      this.$router.push(route) ;        
    },

    async readData () {
      this.loading = true ;
      // let search = this.search.trim().toLowerCase() ;
      // console.log("search " + search + " sortby " + sortBy + " descending " + descending + " page " + page + " rowsPerPage " + rowsPerPage) ;

      console.log("in PST readData") ;
      let result = null ;
      try { // 1 mar22
        result = await PeopleService.index(this.queryParam) ;
      }
      catch (e) {
        console.log("PeopleService index err was " + e) ;
        alert("got error " + e + " - you may need to login") ;
        return ;
      }

      console.log("in PST readData, result=" + result) ;

      this.people = result.data ;
      if (this.people.length < 1) { // at the end
        if (this.finalCount < 0) {
          this.finalCount = this.totalItems ;
          await this.goto(-1) ;
          return ;
        }
      }
      if (this.finalCount < 0) {
        if ((this.queryParam.start >= this.totalItems)) this.totalItems += this.people.length ;
        console.log("  set  this.totalItems " + this.totalItems)
      }
      if (this.people.length < this.queryParam.limit) { // we've tricked to the end
        console.log("set final count to " + this.totalItems)
        this.finalCount = this.totalItems ;
      }
      this.loading = false ;
      console.log("in getdatafrom api data len " + this.people.length)
      if (this.people.length === 1 && (this.queryParam.showUnique === 'y')) { // just show them!
        console.log("One result: " + this.people[0].id) ;
        this.$router.replace('/person/' + this.people[0].id) ;  // replace, not push as we dont want the list to be in history
        // because otherwise, back wont work (will go straight fwd again..)
      }
    },
    async queryRanks (v) {
      this.rankLoading = true ;
      const result = await RankService.filter(v) ;
      this.rankItems = result.data ;
      this.rankLoading = false ;
      console.log("queryRanks data len " + this.rankItems.length)

      /*
      // Simulated ajax query
      setTimeout(() => {
        this.rankItems = this.states.filter(e => {
          return (e || '').toLowerCase().indexOf((v || '').toLowerCase()) > -1
        })
        this.loading = false
      }, 1500)
      */
    },

    getEnlistDate (bios) {
      if (!bios) return "" ;
      for (let bio of bios) {
        if (bio.beTemplateId === this.$constants.enlistedBioEntryId) return bio.date ;
      }
      return "" ;
    }
  },

  // to do: https://vuetifyjs.com/en/components/autocompletes
  
  watch: {
    /*
    'queryParam.service': {
      async handler () {
        console.log("Service changed to " + this.queryParam.service ) ;
        this.reloadSearch() ;
      }
    },
    
    async rankSearch (val) {
      console.log("*****val=" + val + "//") ;
      if (val) {
        if (val !== this.rank) {
          if (val.length > 2) {
            await this.queryRanks(val)
          }
        }
      }
    }
    */
  },
  async mounted () {
       
    if (this.$route.query) {
      const rq = this.$route.query ;

      for (var i = 0 ; i < this.queryFields.length ; i++) {
        const qf = this.queryFields[i] ;
        this.queryParam[qf] = rq[qf] || '' ;
      }
    }

    this.queryParam.unitId = this.forceUnitId ;
    this.queryParam.rankId = this.forceRankId ;
    this.queryParam.rankType = this.forceRankType ;    
    this.queryParam.birthPlaceId = this.forceBirthPlaceId ;
    this.queryParam.honourRollPlaceId = this.forceHonourRollPlaceId ;
    this.queryParam.enlistPlaceId = this.forceEnlistPlaceId ;
    this.queryParam.enlistAddressPlaceId = this.forceEnlistAddressPlaceId ;
    this.queryParam.cemeteryId = this.forceCemeteryId ;
    this.queryParam.homePortPlaceId = this.forceHomePortPlaceId ;
    // this.queryParam.pow = this.forcePow ;
  
    if (!this.showUnitCol) this.headers.pop() ;   // remove last header

    console.log("---------------------------------\nin PST mounted queryParam=" + JSON.stringify(this.queryParam)) ;

    await this.readData() ;
  },
  computed: { 
    isAtStart () {
      return (this.queryParam.start < 1) ;
    },
    isAtEnd () {
      if (this.finalCount < 0) return false ;
      if ((this.queryParam.start + this.queryParam.limit) >= this.finalCount) return true ;
      return false ;
    },
    endIsUnknownOrNotThere () {
      if (this.finalCount < 0) return true ;
      if ((this.queryParam.start + this.queryParam.limit) >= this.finalCount) return true ;
      return false ;
    }
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/PeopleSearchTable.vue